// src/components/ContextMenuModal.js
import React, { useEffect, useRef } from 'react';
import './ContextMenuModal.css';
import FileAttachment from './media/FileAttachment';


const ContextMenuModal = ({ x, y, items, onClose, message }) => {
    const menuRef = useRef(null);
    
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                onClose();
            }
        };

        const handleEscape = (e) => {
            if (e.key === 'Escape') {
                onClose();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleEscape);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleEscape);
        };
    }, [onClose]);

    // Адаптация позиции
    const adjustedX = Math.min(x, window.innerWidth - 250);
    const adjustedY = Math.min(y, window.innerHeight - 400);

    const formatTime = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleTimeString([], {day: '2-digit', month:'short',year: 'numeric', hour: '2-digit', minute: '2-digit' });
        }; 

    return (
        <div className="context-menu-overlay" onClick={onClose}>
            <div 
                ref={menuRef} 
                className="context-menu-modal" 
                style={{ top: adjustedY, left: adjustedX }}
                onClick={(e) => e.stopPropagation()}
            >
                {/* Родительское сообщение (превью) */}
                {message && (
                    <div className="context-menu-parent">
                        <div className="parent-header">
                           {formatTime(message.created_at)}
                        </div>
                        <div className="parent-content">
                            {message.type === 'text' && (
                                <div className="parent-text">{message.content}</div>
                            )}
                            
                            {message.type === 'media' && message.attachments?.length > 0 && (
                                <div className="parent-media">
                                    {message.attachments[0].file_type === 'image' ? (
                                        <FileAttachment 
                                        mediaUrl={message.attachments[0].media_url}
                                        fileName={message.attachments[0].fileName}
                                        className='parent-image'
                                        />
                                        
                                    ) : (
                                        <div className="parent-file">
                                            <i className="bi-file-earmark"></i>
                                            <span>{message.attachments[0].file_type}</span>
                                        </div>
                                    )}
                                </div>
                            )}
                            {message.type==='voice' && (
                                 <div className="parent-media">
                                    <i className='bi-file-mic'></i>
                                       <span>{message.attachments[0].file_type}</span>
                                    </div>
                            )}
                            {message.type === 'sticker' && (
                                <div className="parent-sticker">
                                    <FileAttachment                                                                     
                                    mediaUrl={message.content}                                        
                                    />            
                                </div>
                            )}
                        </div>
                    </div>
                )}
                
                {/* Разделитель */}
                {message && <div className="context-menu-divider"></div>}
                
                {/* Пункты меню */}
                <div className="context-menu-items">
                    {items.map((item, index) => (
                        <div
                            key={index}
                            className={`context-menu-item ${item.disabled ? 'disabled' : ''} ${item.danger ? 'danger' : ''}`}
                            onClick={() => {
                                if (!item.disabled && item.onClick) {
                                    item.onClick();
                                    onClose();
                                }
                            }}
                        >
                            {item.icon && <i className={item.icon}></i>}
                            <span>{item.label}</span>
                            {item.shortcut && <span className="shortcut">{item.shortcut}</span>}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ContextMenuModal;